// extracted by mini-css-extract-plugin
export default {"brandSpace":"TopBrands_brandSpace__Ki63h"};